var $fakeParent = Symbol();

var $fakeNextSibling = Symbol();

var $fakeChildren = Symbol();

var $placeholder = Symbol();

function setFakeParent(node, fakeParent) {
    if (!node[$fakeParent]) {
        node[$fakeParent] = fakeParent;
        Object.defineProperty(node, "parentNode", {
            get: function get() {
                return this[$fakeParent] || this.parentElement;
            }
        });
    }
}

function setFakeNextSibling(node) {
    if (node.hasOwnProperty($fakeNextSibling)) {
        return;
    }
    Object.defineProperty(node, "nextSibling", {
        get: function get() {
            var nextSibling;
            if (this.frag) {
                var lastFakeChild = this.frag[this.frag.length - 1];
                if (lastFakeChild) {
                    nextSibling = lastFakeChild.nextSibling;
                }
            } else {
                var childIndex = Array.from(this.parentElement.childNodes).indexOf(this);
                if (childIndex > -1) {
                    nextSibling = this.parentElement.childNodes.item(childIndex + 1);
                }
            }
            if (nextSibling && !nextSibling.frag && nextSibling[$fakeParent]) {
                nextSibling = nextSibling[$fakeParent];
            }
            if (!nextSibling) {
                return null;
            }
            return nextSibling;
        }
    });
    node[$fakeNextSibling] = true;
}

var resetChildren = function resetChildren(frag, moveTo) {
    var nodes = frag.splice(0);
    moveTo.append.apply(moveTo, nodes);
    nodes.forEach((function(node) {
        node[$fakeParent] = undefined;
    }));
};

function insertBefore(insertNode, insertBeforeNode) {
    var _this = this;
    var insertNodes = insertNode.frag || [ insertNode ];
    if (this.frag) {
        var index = this.frag.indexOf(insertBeforeNode);
        if (index > -1) {
            var _this$frag;
            (_this$frag = this.frag).splice.apply(_this$frag, [ index, 0 ].concat(insertNodes));
        }
    }
    if (this[$fakeChildren]) {
        var hasFakeChildren = this[$fakeChildren].get(insertBeforeNode);
        if (hasFakeChildren) {
            insertBeforeNode = hasFakeChildren[0];
        }
    }
    if (insertBeforeNode) {
        var _insertBeforeNode;
        (_insertBeforeNode = insertBeforeNode).before.apply(_insertBeforeNode, insertNodes);
        if (insertBeforeNode[$fakeParent]) {
            var lastNode = insertNodes[insertNodes.length - 1];
            setFakeNextSibling(lastNode);
        }
    } else {
        this.append.apply(this, insertNodes);
    }
    insertNodes.forEach((function(node) {
        if (node.parentNode !== _this) {
            setFakeParent(node, _this);
        }
    }));
}

function removeChild(node) {
    if (this.frag) {
        var nodeIndex = this.frag.indexOf(node);
        if (nodeIndex > -1) {
            var _this$frag2;
            var spliceArguments = [ nodeIndex, 1 ];
            if (this.frag.length === 1) {
                var placeholder = this[$placeholder];
                this.frag[0].before(placeholder);
                spliceArguments.push(placeholder);
            }
            (_this$frag2 = this.frag).splice.apply(_this$frag2, spliceArguments);
        }
    }
    var fc = this[$fakeChildren];
    if (fc) {
        var hasFakeChildren = fc.get(node);
        if (hasFakeChildren) {
            resetChildren(hasFakeChildren, node);
            fc["delete"](node);
            node[$fakeParent] = undefined;
            return;
        }
    }
    node.remove();
}

var parentPatches = {
    insertBefore: insertBefore,
    removeChild: removeChild
};

function patchParentMethods(parent, child, nodes) {
    if (!parent[$fakeChildren]) {
        parent[$fakeChildren] = new Map;
        Object.assign(parent, parentPatches);
    }
    parent[$fakeChildren].set(child, nodes);
}

var elementPatches = {
    insertBefore: insertBefore,
    before: function before(newNode) {
        this.frag[0].before(newNode);
    },
    remove: function remove() {
        var placeholder = this[$placeholder];
        var frag = this.frag;
        var removed = frag.splice(0, frag.length, placeholder);
        removed[0].before(this[$placeholder]);
        removed.forEach((function(element) {
            return element.remove();
        }));
    },
    removeChild: removeChild,
    appendChild: function appendChild(node) {
        var length = this.frag.length;
        this.frag[length - 1].after(node);
        var placeholder = this[$placeholder];
        if (this.frag[0] === placeholder) {
            this.frag.splice(0, 1);
            placeholder.remove();
        }
        setFakeParent(node, this);
        this.frag.push(node);
    }
};

var frag = {
    inserted: function inserted(element) {
        var parentNode = element.parentNode, nextSibling = element.nextSibling, previousSibling = element.previousSibling;
        var childNodes = Array.from(element.childNodes);
        element.frag = childNodes;
        var placeholder = document.createComment("");
        element[$placeholder] = placeholder;
        if (childNodes.length === 0) {
            childNodes.push(placeholder);
        }
        var fragment = document.createDocumentFragment();
        fragment.append.apply(fragment, childNodes);
        element.replaceWith(fragment);
        patchParentMethods(parentNode, element, childNodes);
        setFakeParent(element, parentNode);
        if (nextSibling) {
            setFakeNextSibling(element);
        }
        if (previousSibling) {
            setFakeNextSibling(previousSibling);
        }
        childNodes.forEach((function(node) {
            return setFakeParent(node, element);
        }));
        Object.defineProperty(element, "innerHTML", {
            set: function set(htmlString) {
                var domify = document.createElement("div");
                domify.innerHTML = htmlString;
                var oldNodesIndex = element.frag.length;
                Array.from(domify.childNodes).forEach((function(node) {
                    return element.appendChild(node);
                }));
                domify.append.apply(domify, element.frag.splice(0, oldNodesIndex));
            },
            get: function get() {
                return "";
            }
        });
        Object.assign(element, elementPatches);
    },
    unbind: function unbind(element) {
        resetChildren(element.frag, element);
        element[$placeholder].remove();
    }
};

export default frag;
